import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import { IconWrapper, Title, MainIcon } from '../../../SharedStyles'
import Icon from 'components/common/Icon/Icon'
import { SHOP_BY_VEHICLE_TITLE, SHOP_BY_SIZE_TITLE } from '../../../constant'

const ValuePropositionBig = ({
  asset,
  title,
  description,
  alt,
  onMouseEnterHandler,
  onMouseLeaveHandler,
  isHover,
  click = () => {},
  hasActiveVehicle,
  activeVehicle: {
    vehicleName,
    formattedSize
  },
  isTrailer
}) =>
  <ValueProposition
    tabIndex="0"
    alt={ alt }
    onMouseEnter={ () => onMouseEnterHandler(alt) }
    onMouseLeave={ onMouseLeaveHandler }
    onClick={ click }>
    <IconWrapper>
      <MainIcon asset={ asset } />
    </IconWrapper>
    <TextWrapper>
      <CustomTitle>{ title }</CustomTitle>
      <Description>{ description }</Description>
      { (hasActiveVehicle && title === SHOP_BY_VEHICLE_TITLE && !isTrailer)
        && <ActiveVehilceInfo>{ vehicleName }</ActiveVehilceInfo> }
      { (hasActiveVehicle && title === SHOP_BY_SIZE_TITLE && !isTrailer && formattedSize)
        && <ActiveVehilceInfo>{`Tire size: ${formattedSize}`}</ActiveVehilceInfo> }
    </TextWrapper>
    <CustomIcon asset={ isHover ? 'arrow-right-white-secondary' : 'arrow-right-red-secondary' } width={ 10 } />
  </ValueProposition>

ValuePropositionBig.propTypes = {
  activeVehicle: PropTypes.shape({
    vehicleName: PropTypes.string,
    formattedSize: PropTypes.string
  }),
  alt: PropTypes.string,
  asset: PropTypes.string,
  click: PropTypes.func,
  description: PropTypes.string,
  hasActiveVehicle: PropTypes.bool,
  isHover: PropTypes.bool,
  isTrailer: PropTypes.bool,
  onMouseEnterHandler: PropTypes.func,
  onMouseLeaveHandler: PropTypes.func,
  title: PropTypes.string
}

export default ValuePropositionBig

const ValueProposition = styled.div`
  background: ${Theme.colors.white};
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  cursor: pointer;
  padding: 34px 25px 32px;
  margin-bottom: 17px;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  ${Media.desktop`
    &:hover {
      background: ${Theme.colors.red};
    }

    &:hover div {
      color: ${Theme.colors.white};
    }
  `}
 
  @media (max-width: 450px) {
    padding: 20px 25px 20px 15px;
    margin-bottom: 10px;
  }
`

const TextWrapper = styled.div`
  margin-left: 15px;

  @media (max-width: 450px) {
    margin-left: 10px;
  }
`

const CustomTitle = styled(Title)`
  margin-bottom: 3px;
  ${Mixin.font.GothamBold(20)};

  @media (max-width: 500px) {
    ${Mixin.font.GothamBold(18)};
  }

  @media (max-width: 400px) {
    ${Mixin.font.GothamBold(13)};
  }
`

const Description = styled.div`
  color: ${Theme.colors.medium_grey};
  ${Mixin.font.GothamMedium(14, 500)};

  @media (max-width: 450px) {
    ${Mixin.font.GothamMedium(12, 500)};
  }
`

const CustomIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;

  @media (max-width: 450px) {
    right: 10px;
  }
`

const ActiveVehilceInfo = styled.div`
  margin-top: 3px;
  color: ${Theme.colors.blue};
  ${Mixin.font.GothamBook(13, 400)};
`
